import { render } from "./HandlerAndroid.vue?vue&type=template&id=649c07cf&scoped=true"
import script from "./HandlerAndroid.vue?vue&type=script&lang=js"
export * from "./HandlerAndroid.vue?vue&type=script&lang=js"

import "./HandlerAndroid.vue?vue&type=style&index=0&id=649c07cf&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649c07cf"]])

export default __exports__